import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
import RichTextEditor from 'react-rte'
import { updateUser, fetchOneUserByUsername, fetchOneUserByAuth } from '../../actions'

const inputStyle = {
  marginBottom: '10px'
}

const labelStyle = {
  marginTop: '18px'
}

class Basic extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rtvalue: '',
      rerenderings: 0,
    }
    this.cancelLink = this.cancelLink.bind(this);
    //this.dataThere = this.dataThere.bind(this);
  }

  componentDidMount() {

    if (this.props.match.params.hasOwnProperty('username')) {
      console.log("did mount with username", this.props.match.params.username);
      this.props.fetchOneUserByUsername(this.props.match.params.username);
    } else {
      this.props.fetchOneUserByAuth();
    }

  }

  cancelLink() {
    var cancelPath = '/';
    const isAdmin = this.isAdmin();
    if (isAdmin) {
      cancelPath = '/user';
    };
    return cancelPath;
  }

  isAdmin() {
    if (!this.props.auth) {
      return false;
    }
    if (this.props.auth.roles.indexOf('admin')>-1) {
      return true;
    } else {
      return false;
    }
  }


  render() {

    var initValues = this.props.singleUser;

    if (initValues) {
      if (!initValues.kdnummer) {
        initValues.kdnummer = 'xyz';
      }
      if (!initValues.fahrerMail) {
        initValues.fahrerMail = '';
      }

      if (typeof initValues.fahrerMail === 'string') {
        initValues.fahrerMail = RichTextEditor.createValueFromString(initValues.fahrerMail, 'html')
      }
    }

      console.log("singleUser:", typeof this.props.singleUser, this.props.singleUser.length);
      console.log(this.state.rerenderings);

      if (typeof this.props.singleUser === 'string') {
        return <Redirect to="/" />
      } else {

          return (
            <div>
              <h2>Voreinstellungen für User {this.props.singleUser.username}, Kunde {this.props.singleUser.kdnummer}</h2>

              <div style={inputStyle}>Hinweis: Username und Kundennummer sind nach der Registrierung nicht mehr veränderbar.</div>

              <Formik
                initialValues={initValues}
                enableReinitialize
                validate={values => {
                  let errors = {};
                  if (!values.email) {
                    errors.email = 'Required';
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                  ) {
                    errors.email = 'Keine gültige Email-Adresse';
                  }
                  if (!values.firstName) {
                    errors.firstName = 'Angabe erforderlich';
                  }
                  if (isNaN(values.fahrerFnCheckInterval)) {
                    errors.fahrerFnCheckInterval = 'Bitte eine ganze Zahl eingeben';
                  }
                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    values.fahrerMail = values.fahrerMail.toString('html');
                    this.props.updateUser( values, this.props.history );

                    setSubmitting(false);
                }}
              >

                {({ isSubmitting, props, setFieldValue, initValues, values }) => (

                  <Form>
                    <label htmlFor="firstName">Vorname</label>
                    <Field name="firstName" style={inputStyle} placeholder="Vorname" />
                    <ErrorMessage name="firstName" component="div" />

                    <label htmlFor="lastName" style={labelStyle}>Nachname</label>
                    <Field name="lastName" style={inputStyle} />
                    <ErrorMessage name="lastName" component="div" />

                    <label htmlFor="credits" style={labelStyle}>Anzahl Fahrer</label>
                    {this.isAdmin() ?
                    <Field name="credits" style={inputStyle} /> :
                    <Field name="credits" style={inputStyle} disabled />}
                    <ErrorMessage name="credits" component="div" />

                    <label htmlFor="" style={labelStyle}>Emailtext für Fahrer</label>

                    <Field name="fahrerMail" component={CustomRichTextComponent} key={values.username} />

                    <label htmlFor="roles" style={labelStyle}>Rollen</label>
                    {this.isAdmin() ?
                    <Field
                      style={inputStyle}
                      component="select"
                      name="roles"
                      onChange={evt =>
                        setFieldValue(
                          "roles",
                          [].slice
                          .call(evt.target.selectedOptions)
                          .map(option => option.value)
                        )
                      }
                      multiple={true}>
                      <option value="fuhrparkleiter">Fuhrparkleiter</option>
                      <option value="admin">Admin</option>
                      <option value="demo">Demo</option>
                    </Field> :
                    <Field
                      style={inputStyle}
                      component="select"
                      name="roles"
                      disabled
                      onChange={evt =>
                        setFieldValue(
                          "roles",
                          [].slice
                          .call(evt.target.selectedOptions)
                          .map(option => option.value)
                        )
                      }
                      multiple={true}>
                      <option value="fuhrparkleiter">Fuhrparkleiter</option>
                      <option value="admin">Admin</option>
                      <option value="demo">Demo</option>
                    </Field>}
                    <ErrorMessage name="roles" component="div" />



                    <label htmlFor="fahrerFnCheckInterval" style={labelStyle}>Führerscheincheck-Intervall (Checks pro Jahr)</label>
                    <Field
                      style={inputStyle}
                      component="select"
                      name="fahrerFnCheckInterval"
                      onChange={evt =>
                        setFieldValue(
                          "fahrerFnCheckInterval",
                          evt.target.selectedOptions[0].value
                        )
                      }
                      multiple={false}>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={6}>6</option>
                    </Field>

                    {/*<Field name="fahrerFnCheckInterval" style={inputStyle} />*/}
                    <ErrorMessage name="fahrerFnCheckInterval" component="div" />

                    <label htmlFor="fahrerFnCheckAutoInterval" style={labelStyle}>Nächstes Führerscheincheck-Datum automatisch berechnen</label>
                    <input
                      name="fahrerFnCheckAutoInterval"
                      id="fahrerFnCheckAutoInterval"
                      type="checkbox"
                      value={values.fahrerFnCheckAutoInterval}
                      checked={values.fahrerFnCheckAutoInterval}
                      style={{display:'block'}}
                      onChange={e => setFieldValue('fahrerFnCheckAutoInterval', !values.fahrerFnCheckAutoInterval)}
                    />
                    <ErrorMessage name="fahrerFnCheckAutoInterval" component="div" />

                    <label htmlFor="erinnerungenFscheck" style={labelStyle}>Erinnerungsfunktion FS-Check aktiv</label>
                    <input
                      name="erinnerungenFscheck"
                      id="erinnerungenFscheck"
                      type="checkbox"
                      value={values.erinnerungenFscheck}
                      checked={values.erinnerungenFscheck}
                      style={{display:'block'}}
                      onChange={e => setFieldValue('erinnerungenFscheck', !values.erinnerungenFscheck)}
                    />
                    <ErrorMessage name="erinnerungenFscheck" component="div" />

                    <label htmlFor="erinnerungenLasi" style={labelStyle}>Erinnerungsfunktion LaSi-Tutorial aktiv</label>
                    <input
                      name="erinnerungenLasi"
                      id="erinnerungenLasi"
                      type="checkbox"
                      value={values.erinnerungenLasi}
                      checked={values.erinnerungenLasi}
                      style={{display:'block'}}
                      onChange={e => setFieldValue('erinnerungenLasi', !values.erinnerungenLasi)}
                    />
                    <ErrorMessage name="erinnerungenLasi" component="div" />

                    <label htmlFor="email" style={labelStyle}>Email</label>
                    <Field name="email" style={inputStyle} />
                    <ErrorMessage name="email" component="div" />

                    <Link to={this.cancelLink()} style={{marginRight: '10px'}} type="cancel">
                      <button className="btn btn-secondary" >
                      <span style={{color: 'white'}}>Abbrechen</span>
                      </button>
                    </Link>

                    <button className="btn btn-default" type="submit" disabled={isSubmitting}>
                      Absenden
                    </button>
                  </Form>
                )}
              </Formik>

              <div style={{height: "80px"}}></div>

            </div>
          )}
        }
}

class CustomRichTextComponent extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  state = {
    value: this.props.form.values.fahrerMail,
    key: this.props.form.values.username
  }

  componentDidUpdate() {
    // Dirty Hack? Wir müssen den value nachladen, wenn die Userdaten im Parent dann geladen sind.
    // Die Abfrage dient dazu, dass es keinen ifinite Loop gibt.
    if (this.state.value.toString("html") === "" && this.props.field.value.toString('html') !== "" ) {
      this.setState({value: this.props.field.value})
    }
  }

  onChange(e) {
    const newString = e.toString('html');
    this.setState({value: e});
    this.props.form.values.fahrerMail = newString;
  }

  render () {
    return (
      <div>
        <RichTextEditor
           value={this.state.value}
           onChange={this.onChange}
         />
       {this.props.form.touched[this.props.field.name] &&
          this.props.form.errors[this.props.field.name] && <div className="error">{this.props.form.errors[this.props.field.name]}</div>}
      </div>
    )
  }
}


const mapDispatchToProps = {
	updateUser,
  fetchOneUserByUsername,
  fetchOneUserByAuth
}

function mapStateToProps({ auth, singleUser }) {
	return { auth, singleUser }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Basic);



// WEBPACK FOOTER //
// ./src/components/user/UserPrefs.js